import React from "react";
import { classNames, useStore } from "../../helpers";
import { observer } from "mobx-react-lite";
import { VoterCard } from "../manage-voters/Voters";
import { Radio, RadioGroup } from "@headlessui/react";
import Masonry from "@mui/lab/Masonry";
import { FormButtons } from "../../components";
import { useWindowSize } from "react-use";
import { Stack } from "@mui/material";

export const VoterListWithRadioButton = observer((props: any) => {
    const { voterListStore } = useStore();
    const { Voterlist, activeVoter, isSideOverlay } = voterListStore;
    const { height } = useWindowSize();
    const rootStore = useStore();
    const { beneficiaryStore } = rootStore;

    const searchVotersHandler = async (val) => {
        await voterListStore.update_active_voter(val);
        close();
    };

    const close = () => {
        setTimeout(() => {
            voterListStore.setShowVoterlist(false);
            beneficiaryStore.update_add_beneficiary_modal(true);
        }, 300);
    };
    return (
        <div className={"flex flex-col"}>
            <div
                className={
                    "absolute right-2 top-0 z-10 w-full bg-white md:hidden"
                }
            >
                <FormButtons
                    onSave={close}
                    onCancel={() => {
                        close();
                        voterListStore.update_active_voter({});
                    }}
                />
            </div>
            <Stack
                className={
                    "max-h-[] overflow-auto md:max-h-[55%] lg:max-h-[55%] xl:max-h-[65%]"
                }
                sx={{
                    maxHeight: { sm: height * 0.8, md: height * 0.65 },
                    overflow: "auto",
                }}
            >
                <RadioGroup
                    value={activeVoter}
                    onChange={(val) => searchVotersHandler(val)}
                    className="rounded-3xl bg-grey-300 p-2"
                >
                    <Masonry
                        columns={
                            isSideOverlay ? 1 : { sm: 1, md: 2, lg: 3, xl: 3 }
                        }
                    >
                        {Voterlist &&
                            Voterlist.length > 0 &&
                            Voterlist.map((option) => (
                                <Radio
                                    key={option.label}
                                    value={option}
                                    aria-label={option.label}
                                    className={classNames(
                                        option.id === activeVoter["id"]
                                            ? "rounded-3xl bg-primary-light"
                                            : "bg-transparent",
                                        "relative flex cursor-pointer items-center justify-center rounded-3xl p-2 transition duration-500 ease-in-out focus:outline-none"
                                    )}
                                >
                                    <div
                                        style={
                                            isSideOverlay
                                                ? { width: "500px" }
                                                : {}
                                        }
                                    >
                                        <VoterCard voterdata={option} />
                                    </div>
                                </Radio>
                            ))}
                    </Masonry>
                </RadioGroup>
            </Stack>
            <div className={"bg-white p-4"}>
                <FormButtons
                    onSave={close}
                    onCancel={() => {
                        close();
                        voterListStore.update_active_voter({});
                    }}
                />
            </div>
        </div>
    );
});
